const MESSAGING_CID_PREFIX = "messaging:";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

/**
 * Extracts the channel id from the data Stream attaches to its pushes — nested `stream.cid` on
 * APNs, top-level `cid` from the FCM data template (e.g. `"messaging:abc123"`). Pure so it can be
 * unit-tested without the Capacitor plugin. Null for anything that is not a messaging-channel push.
 */
export const parseChatChannelIdFromPush = (data: unknown): string | null => {
  if (!isRecord(data)) {
    return null;
  }

  const cid = isRecord(data.stream) ? data.stream.cid : data.cid;

  if (typeof cid !== "string" || !cid.startsWith(MESSAGING_CID_PREFIX)) {
    return null;
  }

  const channelId = cid.slice(MESSAGING_CID_PREFIX.length);
  return channelId.length > 0 ? channelId : null;
};
